import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Stack, Typography, Card, Box } from "@mui/material";
import PropTypes from "prop-types";
import GroupBySelect from "../GroupBySelect";
import DateRangePicker from "../DateRangePicker";
import PieChart from "./PieChart/PieChart";
import { getFilteredAnalyticsData } from "../utils/getFilteredAnalyticsData";
import { subDays } from "date-fns";
const options = ["toolName", "mediaOption"];
const SpendReport = ({ data }) => {
    const [groupBy, setGroupBy] = useState("toolName");
    const [duration, setDuration] = useState({
        from: subDays(new Date(), 6),
        to: new Date(),
    });
    const [filteredData, setFilteredData] = useState(getFilteredAnalyticsData(data, groupBy, duration));
    const handleSelectedOption = (value) => {
        setGroupBy(value);
        setFilteredData(getFilteredAnalyticsData(data, value, duration));
    };
    const setDates = (dates) => {
        setDuration(() => (dates));
        setFilteredData(getFilteredAnalyticsData(data, groupBy, dates));
    };
    return (_jsxs(Card, Object.assign({ sx: { p: '16px 16px 24px 16px' } }, { children: [_jsxs(Box, Object.assign({ display: "flex", justifyContent: "space-between", alignItems: "center", mb: "30px" }, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: "Spend Report" })), _jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", spacing: 3 }, { children: [_jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: "Filter by" })), _jsx(GroupBySelect, { selected: groupBy, onSelect: handleSelectedOption }), _jsx(DateRangePicker, { duration: duration, setDuration: setDates })] }))] })), filteredData.length ? (_jsx(PieChart, { data: filteredData, groupBy: groupBy })) : (_jsx(Stack, Object.assign({ style: { height: "370px" }, justifyContent: "center", alignItems: "center" }, { children: _jsx(Typography, Object.assign({ variant: "h2" }, { children: "No data found for the selected duration" })) })))] })));
};
SpendReport.propTypes = {
    data: PropTypes.array,
};
export default SpendReport;
